export default function formatStocktakeStatus(data) {
  if (data.is_different && data.submitted_at === null) return "未提交差異原因";
  if (data.is_different && data.submitted_at !== null) return "已提交差異原因";
  if (!data.is_different) return "已完成盤點";
}
